module.exports = __webpack_public_path__ + "resources/img/img-security-securegate-2-jp.fcd898932d1d1e8d1ac7934acbedc630.png";